import {Vue, Component, Prop, PropSync, Provide, ProvideReactive, Watch} from 'vue-property-decorator';
import Trip from "app/shared/models/trip.model";
import Itinerary from "../models/itinerary.model";
import { Validator } from "vee-validate";

@Component<IndieInput>({
  components: ({})
})
export default class IndieInput extends Vue {
  @Prop() private cityList!: Array<Itinerary>;
  @Prop() private onCityChange!: Function;
  @Prop() private placeholder!: string;
  @Prop() private name!: string;
  @Prop() private trip!: Trip;
  @Prop() private cityValidate!: Function;
  @Prop() private tripCity!: string;
  @Prop() private searchInProcess!: boolean;
  @Prop() private getCities!: Function;
  @Prop() private img!: string;
  @Prop() private positionIconFly: boolean;
  @Prop() private changeOption: string;
  @Prop() private passengerId!: number;
  @Prop() private listIsEmpty: boolean;
  @Prop() private isValidForm: boolean;
  @Prop() private searchButtonIsClicked: boolean;
  @Prop() public dataFor: string;
  @Prop() public dataForIndex: number;

  public isDropUp = false;
  public scrolled: boolean = false;
  public class = "";
  public code: string = "";

  private isFocus = false;
  private city = this.tripCity || "";
  private state = "";
  private country = "";


  constructor() {
    super();
    this.class = this.placeholder;
    if (this.placeholder === "Departure city" && this.trip.fromCityObject) {
      this.code = this.trip.fromCode;
    } else if (this.placeholder === "Arrival city" && this.trip.toCityObject) {
      this.code = this.trip.toCode;
    }
  }

  mounted() {
    return true;
  }

  created() {
    window.addEventListener("scroll", this.handleScroll);
  }

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  updated() {
    this.toggleDropUp();
  }

  public cityChange(trip: Trip, city: string, cityItem: any) {
    if (this.trip) {
      this.onCityChange(this.trip, this.city, cityItem);
      this.cityValidate(this.city);
    } else {
      this.onCityChange(cityItem, this.name);
    }
    this.$emit("input", this.city);
  }

  public toCityExist() {
    let isExist = false;
    if (!this.cityList) {
      return isExist;
    }
    this.cityList.filter((city: Itinerary) => {
      if (city.city.toLowerCase().includes(this.city.toLowerCase())) {
        isExist = true;
      }
    });
    return isExist;
  }

  private handleScroll() {
    this.scrolled = window.scrollY > 0;
    this.toggleDropUp();
  }

  private onFocus() {
    this.isFocus = true;
  }

  private onBlur() {
    this.isFocus = false;
  }

  private toggleDropUp() {
    let dropdownContainer = this.$el.querySelector(".indieInput");

    let position;
    let buttonHeight;

    if (dropdownContainer) {
      position = dropdownContainer.getBoundingClientRect().top;
      buttonHeight = dropdownContainer.getBoundingClientRect().height;
    }

    let dropdownMenu: any = this.$el.querySelector(".dropdown");
    if (dropdownMenu) var menuHeight = dropdownMenu.offsetHeight;

    let win: any = window.innerHeight;

    if (menuHeight && position) {
      if (
        position > menuHeight &&
        win - position - 5 < buttonHeight + menuHeight
      ) {
        this.isDropUp = true;
      } else {
        this.isDropUp = false;
      }
    }
  }
}
